import './EventsFiltersPanel.scss';
import 'styles/mixins/_breakpoints.scss';

import { Button, Chip } from '@trackman/web-shared-components';
import { TrackmanEventFilter } from 'types/trackmanEvents';

import { ReactComponent as CloseIcon } from 'images/icons/Close.svg';
import Paragraph from 'components/TextComps/Paragraph';
import Separator from 'components/Separator/Separator';
import Subtitle from 'components/TextComps/Subtitle';
import { useTranslation } from 'react-i18next';
import { Drawer, useMediaQuery } from '@mui/material';

type FilterConfig = {
  label: string;
  options: TrackmanEventFilter[];
};

type Props = {
  open: boolean;
  filtersConfig: FilterConfig[];
  selectedFilters: TrackmanEventFilter[];
  onFilterClick: (filter: TrackmanEventFilter) => void;
  onClearFilters: () => void;
  showFilters: (value: boolean) => void;
};

export const EventsFiltersPanel = ({ open, filtersConfig, selectedFilters, onFilterClick, onClearFilters, showFilters }: Props) => {
  const { t } = useTranslation();
  const isMediumScreen = useMediaQuery('(max-width:768px)');

  return (
    <Drawer className='event-filters-drawer' open={open} anchor={isMediumScreen ? 'bottom' : 'right'} onClose={() => showFilters(false)}>
      <div className='event-filters'>
        <div className='event-filters-header'>
          <Subtitle>
            <>{t('Filter', { ns: 'trackmanEvents' })}</>
          </Subtitle>

          <CloseIcon className='close-event-filters-drawer' onClick={() => showFilters(false)} />
        </div>
        <Separator />
        {filtersConfig.map((filter, index) => (
          <div key={index} className='event-filters-body'>
            <Paragraph className='event-filter-option-label'>
              <>{filter.label}</>
            </Paragraph>
            <div className='event-filter-options'>
              {filter.options.map((option) => {
                const isSelected = selectedFilters?.some((item) => item.label === option.label);
                return (
                  <Chip
                    key={option.label}
                    className={isSelected ? 'selected-event-filter' : ''}
                    clickable
                    label={option.label}
                    onClick={() => onFilterClick(option)}
                  />
                );
              })}
            </div>
            {index < filtersConfig.length - 1 ? <Separator /> : null}
          </div>
        ))}
        <div className='event-filters-footer'>
          <Button className='styled-button tertiary' onClick={() => (selectedFilters.length ? onClearFilters() : showFilters(false))}>
            <>{selectedFilters.length ? t('ClearAll', { ns: 'trackmanEvents' }) : t('Cancel', { ns: 'general' })}</>
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
